import React, { useState } from 'react';
import { Button } from '../ui/button';
import { User, Users, Smile, UserPlus, Target } from 'lucide-react';

const FreeTimeStep = ({ data, updateData, onNext }) => {
  const [selectedTime, setSelectedTime] = useState(data.freeTime || '');

  const options = [
    { id: 'alone', label: 'Enjoying being alone', icon: User },
    { id: 'friends-family', label: 'With friends and family', icon: Users },
    { id: 'hobbies', label: 'Engaging in hobbies', icon: Smile },
    { id: 'meeting-people', label: 'Meeting new people', icon: UserPlus },
    { id: 'productive', label: 'Staying productive', icon: Target }
  ];

  const handleSelect = (optionId) => {
    setSelectedTime(optionId);
    updateData('freeTime', optionId);
  };

  const handleContinue = () => {
    if (selectedTime) {
      onNext();
    }
  };

  return (
    <div className="text-center">
      <h1 className="text-white text-2xl md:text-3xl font-bold mb-4">
        How do you usually spend your free time?
      </h1>
      <p className="text-white/70 text-sm md:text-base mb-8">
        How do you usually spend your free time?
      </p>

      <div className="space-y-4 mb-8">
        {options.map((option) => {
          const IconComponent = option.icon;
          return (
            <button
              key={option.id}
              onClick={() => handleSelect(option.id)}
              className={`w-full py-4 px-6 rounded-full text-base md:text-lg font-bold transition-all duration-300 hover:scale-105 flex items-center justify-center gap-3 ${
                selectedTime === option.id
                  ? 'bg-[#F1B428] text-black shadow-lg shadow-[#F1B428]/30 scale-105'
                  : 'bg-white/5 backdrop-blur-sm text-white border border-white/10 hover:border-[#F1B428]/50'
              }`}
            >
              {option.label}
            </button>
          );
        })}
      </div>

      <Button
        onClick={handleContinue}
        disabled={!selectedTime}
        className="w-full max-w-sm bg-[#F1B428] hover:bg-[#D9A022] text-black font-bold text-lg py-6 rounded-full transition-all duration-300 hover:scale-105 shadow-lg shadow-[#F1B428]/30 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Continue
      </Button>
    </div>
  );
};

export default FreeTimeStep;
